import React from "react";
import useQuantityAwareTranslation from "@Translation/hooks/useQuantityAwareTranslation";

interface BusChangePopoverTriggerProps {
    stops: any[]
}

function BusChangePopoverTrigger({stops}: BusChangePopoverTriggerProps) {
    const busChangeLabel = useQuantityAwareTranslation("sys.bus_change", stops.length)
    return (
        <span>
            <span className="gb--route-change">{stops.length}</span>
            <span>{busChangeLabel}</span>
        </span>
    )
}

export default BusChangePopoverTrigger